export enum AccountType {
    Single = "single",
    Couple = "couple",
    Joint = "joint",
    Individual = "individual",
    Club = "club",
    Host = "host"
}